<template>
    <section id="homeHero">
        <b-container>
            <div class="col-md-11 mx-auto">
                <h1 class="font56 text-white font-weight-bold pt-5 m-0">{{header}}</h1>
                <p v-if="subHeader.length > 0 && userStatus" class="font24 text-white font-weight-bold pb-5 mobile_font18">{{subHeader}}</p>
                <p v-if="subHeaderUnAuthenticated.length > 0 && !userStatus" class="font18 text-white font-weight-bold pb-5" v-html="subHeaderUnAuthenticated"></p>
            </div>
        </b-container>
    </section>
</template>
<script>
export default {
     props: {
    header: {
      default: "",
      type: String
    },
    subHeader: {
      default: "",
      type: String
    },
    subHeaderUnAuthenticated:{
      default: "",
      type: String
    },
    userStatus:{
      default: false,
      type: Boolean
    }
  }
}
</script>
